import { StorefrontPageProps } from "@/types";
import { Link, usePage } from "@inertiajs/react";
import { Globe } from "lucide-react";
import { ReactNode } from "react";
import facebookSvg from "/assets/facebook.svg";
import instagramSvg from "/assets/instagram.svg";
import twitterSvg from "/assets/twitter.svg";
import MetaTags from "./meta-tags";
import { storefront_store_root_path } from "@/lib/routes";
import useTranslations from "@/hooks/use-translations";

const SOCIAL_ICONS: Record<string, string> = {
  facebook: facebookSvg,
  instagram: instagramSvg,
  twitter: twitterSvg,
};

export default function StorefrontLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { current_store } = usePage<StorefrontPageProps>().props;
  const { t } = useTranslations("shared.components.storefront_layout");

  return (
    <>
      <MetaTags />

      <div className="flex w-full flex-col gap-6 p-4 overflow-auto">
        <nav className="flex justify-between items-center">
          <Link href={storefront_store_root_path()}>
            <h1 className="text-2xl md:text-xl font-semibold">
              {current_store.name}
            </h1>
          </Link>
          <div className="flex gap-3">
            {current_store.social_links.map((socialLink) => (
              <a key={socialLink.url} href={socialLink.url} target="_blank">
                {SOCIAL_ICONS[socialLink.type] === "other" ? (
                  <Globe className="size-6" />
                ) : (
                  <img src={SOCIAL_ICONS[socialLink.type]} className="size-6" />
                )}
              </a>
            ))}
          </div>
        </nav>

        {children}

        <p
          className="text-sm text-center text-gray-500"
          dangerouslySetInnerHTML={{ __html: t("footer_html") }}
        />
      </div>
    </>
  );
}
